var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleOutlineIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.057,
    height: 33.057,
    viewBox: "0 0 33.057 33.057",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-checkmark-circle-outline",
    "data-name": "Icon ionic-ios-checkmark-circle-outline",
    transform: "translate(-3.125 -3.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M27.2,13.717,25.821,12.3a.3.3,0,0,0-.219-.094h0a.284.284,0,0,0-.219.094l-9.548,9.618L12.36,18.444a.3.3,0,0,0-.438,0l-1.393,1.393a.312.312,0,0,0,0,.446l4.383,4.383a1.386,1.386,0,0,0,.916.446,1.452,1.452,0,0,0,.908-.43h.008L27.206,14.163A.335.335,0,0,0,27.2,13.717Z",
    transform: "translate(0.798 0.998)",
    fill: "#79b62f",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M19.653,5.566A14.081,14.081,0,1,1,9.691,9.691a13.994,13.994,0,0,1,9.963-4.124m0-2.191A16.278,16.278,0,1,0,35.932,19.653,16.276,16.276,0,0,0,19.653,3.375Z",
    transform: "translate(0 0)",
    fill: "#79b62f",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleOutlineIcon);
export default __webpack_public_path__ + "static/media/circle-outline-icon.80cacdfa9605575548e9093aae258625.svg";
export { ForwardRef as ReactComponent };